import { useDownloadMediaUriFilename } from "@/api/media";

export function useDocumentDownload() {
  const { mutate, isPending, isSuccess, isError, reset } =
    useDownloadMediaUriFilename();
  return {
    download: ({ path, fileName }: { path: string; fileName: string }) => {
      mutate({
        path,
        fileName,
      });
    },
    isDownloading: isPending,
    isSuccessDownload: isSuccess,
    isErrorDownload: isError,
    resetDownload: reset,
  };
}
